import type { StringTable } from '../types'

export const de: StringTable = {
  'common.playbackSpeed': 'Wiedergabegeschwindigkeit',
  // Navigation
  'nav.review': 'Wiederholen',
  'nav.library': 'Bibliothek',
  'nav.stats': 'Statistik',
  'nav.settings': 'Einstellungen',
  'nav.appTitleSuffix': 'Vokabelkarten',
  'nav.openMenu': 'Menü öffnen',
  'nav.closeMenu': 'Menü schließen',
  'nav.mainNav': 'Hauptnavigation',
  'nav.reviewSession': 'Wiederholungssitzung',
  'nav.cardLibrary': 'Kartenbibliothek',
  'nav.media': 'Videos',
  'nav.statistics': 'Statistiken',
  'nav.create.label': 'Erstellen',
  'nav.create.text': 'Text',
  'nav.create.doc': 'Dokument',
  'nav.create.media': 'Video / Audio',

  // Generate view
  'generate.takePhoto': 'Kamera',
  'generate.changePhoto': 'Foto ändern',
  'generate.chooseGallery': 'Galerie',
  'generate.clearText': 'Text löschen',
  'generate.button': 'Karten erstellen',
  'generate.buttonPhoto': 'Aus Foto erstellen',
  'generate.buttonText': 'Aus Text erstellen',
  'generate.buttonBoth': 'Aus Foto + Text erstellen',
  'generate.buttonLoading': 'Wird erstellt...',
  'generate.minInput': 'Foto oder Text hinzufügen zum Starten',
  'generate.convertingHeic': 'HEIC wird umgewandelt...',
  'generate.compressing': 'Wird komprimiert...',
  'generate.retry': 'Erneut versuchen',
  'generate.removeImage': 'Bild entfernen',
  'generate.cardTextInput': 'Kartentexteingabe',
  'generate.preview': 'Vorschau',

  // Generate errors
  'generate.error.invalidImage': 'Bitte lade ein Bild hoch (JPEG, PNG, GIF, WebP oder HEIC)',
  'generate.error.imageTooLarge': 'Das Bild darf maximal {{maxSize}} groß sein',
  'generate.error.compressionFailed': 'Das Bild ist nach der Komprimierung immer noch zu groß. Versuche ein kleineres Foto.',
  'generate.error.heicFailed': 'Bild konnte nicht verarbeitet werden',
  'generate.error.generateFailed': 'Karten konnten nicht erstellt werden',

  // Generate — daily cap / upgrade
  'generate.cap.body': 'Dein Guthaben ist leer ({{balance}} Energie). Aufladen, um weiter zu generieren.',
  'generate.cap.upgrade': 'Aufladen',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': 'Energie-Guthaben: {{balance}}',
  'generate.energyBadge.zero': 'Keine Energie mehr',
  'generate.firstCard.body': 'Du hast {{balance}} Energie — genug für deine ersten Karten. Tippe unten ein Wort ein und probiere es →',
  'generate.firstCard.dismiss': 'Schließen',
  'generate.sampleWords.label': 'Probier eines:',
  'generate.aiImageToggle': 'KI-Bild',
  'generate.aiImageHint': 'Füge ein KI-Bild hinzu bei Karten, die du behältst ({{cost}}/Karte)',
  'generate.aiImageAutoSkip': 'Einige KI-Bilder konnten nicht hinzugefügt werden — tippe auf jeder Karte den Bild-Button zum Wiederholen.',

  // Library view
  'library.loading': 'Bibliothek wird geladen...',
  'library.retry': 'Erneut versuchen',
  'library.noCards': 'Noch keine Karten!',
  'library.noCardsHint': 'Erstelle ein paar Karten, um deine Bibliothek aufzubauen.',
  'library.emptyExtensionHint': 'Tipp: Markiere beim YouTube-Schauen ein Wort und speichere es mit der Piccard-Erweiterung.',
  'library.emptyCta': 'Erste Karte erstellen',
  'library.dismiss': 'Schließen',
  'library.deleteTitle': 'Karte löschen?',
  'library.deleteConfirm': 'Diese Aktion kann nicht rückgängig gemacht werden. Bist du sicher?',
  'library.cancel': 'Abbrechen',
  'library.deleting': 'Wird gelöscht...',
  'library.delete': 'Löschen',
  'library.filterAll': 'Alle',
  'library.filterLearning': 'Am Lernen',
  'library.filterMastered': 'Gelernt',
  'library.card_one': '{{count}} Karte',
  'library.card_other': '{{count}} Karten',
  'library.match_one': '{{count}} Treffer',
  'library.match_other': '{{count}} Treffer',
  'library.noCardsMatch': 'Keine Karten passen zu „{{query}}"',
  'library.prevPage': 'Vorherige Seite',
  'library.nextPage': 'Nächste Seite',
  'library.searchImagesFor': 'Bilder für {{word}} suchen',
  'library.unmaster': '{{word}} als nicht gelernt markieren',
  'library.markMastered': '{{word}} als gelernt markieren',
  'library.searchPlaceholder': '{{filter}}Karten durchsuchen...',
  'library.drag': 'ZIEHEN',
  'library.swipeHint': '← Löschen · Ansehen →',
  'library.back': 'Rückseite',
  'library.images': 'Bilder',
  'library.master': 'Gelernt',
  'library.mastered': 'Gelernt',
  'library.view': 'Ansehen',
  'library.fromMedia': 'Aus Medien',
  'library.fromDoc': 'Aus Dokument',

  // Review view
  'review.ready': 'Bereit zum Wiederholen?',
  'review.readyHint': 'Wähle ein Thema oder starte mit allen fälligen Karten',
  'review.recognition': 'Erkennen',
  'review.production': 'Produzieren',
  'review.topics': 'Themen',
  'review.domains': 'Bereiche',
  'review.startReview': 'Wiederholung starten',
  'review.loading': 'Karten werden geladen...',
  'review.retry': 'Erneut versuchen',
  'review.tapFlip': 'Tippen zum Umdrehen',
  'review.answer': 'Antwort',
  'review.newWord': 'Neues Wort',
  'review.cardProgress': 'Karte {{current}} von {{total}}',
  'review.searchImagesFor': 'Bilder für {{word}} suchen',
  'review.allCaughtUp': 'Alles geschafft!',
  'review.nothingToReview': 'Aktuell nichts zu wiederholen.',
  'review.makeSomeCards': 'Karten erstellen',
  'review.makeMoreCards': 'Weitere „{{topic}}"-Karten erstellen',
  'review.backToReview': 'Zurück zur Wiederholung',
  'review.noMatchTitle': 'Keine Karten passen zu „{{topic}}"',
  'review.noMatchHint': 'Inklusive Karten, die teilweise zu deinem Thema passen',
  'review.fallbackTitle': 'Keine Karten passen zu „{{topic}}" — hier sind alle fälligen Karten',
  'review.sessionComplete': 'Sitzung abgeschlossen!',
  'review.cardsReviewed': 'Karten wiederholt',
  'review.again': 'Nochmal',
  'review.hard': 'Schwer',
  'review.good': 'Gut',
  'review.easy': 'Leicht',
  'review.timeSpent': 'Zeitaufwand',
  'review.cardReviewed_one': '{{count}} Karte heute wiederholt',
  'review.cardReviewed_other': '{{count}} Karten heute wiederholt',
  'review.startNewSession': 'Neue Sitzung starten',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': 'Heutige Karte teilen',
  'share.title': 'Fortschritt teilen',
  'share.name': 'Anzeigename',
  'share.create': 'Share-Link erstellen',
  'share.copied': 'Link kopiert!',
  'share.open': 'Share-Seite öffnen',
  'share.saveImage': 'Poster-Bild speichern',
  'share.myLinks': 'Meine geteilten Links',
  'share.revoke': 'Widerrufen',
  'share.empty': 'Noch keine Links — beende eine Lernsession, um deine Serie zu teilen.',
  'review.tapOrSpace': 'Karte antippen oder Leertaste drücken zum Umdrehen',
  'review.images': 'Bilder',
  'review.prefillMore': 'weitere Wörter und Ausdrücke zu {{topic}}',
  'review.endSession': 'Sitzung beenden',
  'review.error.loadFailed': 'Karten konnten nicht geladen werden',
  'review.error.submitFailed': 'Wiederholung konnte nicht gespeichert werden',

  // Stats view
  'stats.today': 'Heute',
  'stats.reviewedToday': 'heute wiederholt',
  'stats.review_one': 'Wiederholung',
  'stats.review_other': 'Wiederholungen',
  'stats.mastered': 'gelernt',
  'stats.learned': 'gelernte Wörter',
  'stats.word_one': 'Wort',
  'stats.word_other': 'Wörter',
  'stats.error': 'Statistiken konnten nicht geladen werden',
  'stats.dailyGoal': 'Tagesziel',
  'stats.goalFresh': 'Ein neuer Start.',
  'stats.goalGoing': 'Weiter so.',
  'stats.goalMet': 'Ziel erreicht, gut gemacht.',
  'stats.goalHint': 'Tippen für dein Tempo',

  // Settings view
  'settings.title': 'Einstellungen',
  'settings.languagePair': 'Sprachpaar',
  'settings.learn': 'Lernen',
  'settings.pairOption': '{{native}} → {{target}} lernen',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': 'Karten pro Sitzung',
  'settings.cardLabel': '{{count}} Karten',
  'settings.changeWarning': 'Sprache ändern lädt die App neu',
  'settings.apply': 'Anwenden',
  'settings.cancelChange': 'Abbrechen',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': 'Lernziel',
  'settings.learningContext.optional': 'optional',
  'settings.learningContext.placeholder': 'z. B. GRE-Vokabular, HSK, Business-Englisch…',
  'settings.learningContext.hint': 'Beeinflusst die Wortwahl der KI. Leer für Standardwerte.',
  'settings.learningContext.try': 'Vorschlag:',
  'settings.learningContext.example1': 'HSK-Vorbereitung',
  'settings.learningContext.example2': 'Business-Englisch',
  'settings.learningContext.example3': 'Alltagskonversation',
  'settings.learningContext.example4': 'Australisches Englisch',

  // Settings — subscription
  'settings.plan.balanceTitle': 'Energie-Guthaben',
  'settings.plan.balanceDesc': '{{balance}} Energie verfügbar',
  'settings.plan.topup': '${{amount}} aufladen',
  'settings.plan.energyUnit': '{{energy}} Energie',
  'settings.plan.bonusPct': '+{{percent}}% Bonus',
  'settings.plan.bestValue': 'Bester Wert',
  'settings.support.title': 'Hilfe nötig?',
  'settings.support.desc': 'Fragen, Abrechnung oder Feedback — schreib uns.',
  'settings.referral.title': 'Freunde einladen, ihr bekommt beide 150 Energie',
  'settings.referral.desc': 'Teile deinen Link. Wenn ein Freund auflädt, bekommt ihr jeweils 150 Energie gratis.',
  'settings.referral.yourCode': 'Dein Einladungscode',
  'settings.referral.copyCode': 'Einladungscode kopieren',
  'settings.referral.tapToCopy': 'Zum Kopieren tippen',
  'settings.referral.codeCopied': 'Kopiert',
  'settings.referral.shareLink': 'Link teilen',
  'settings.referral.invited_one': '{{count}} Freund eingeladen',
  'settings.referral.invited_other': '{{count}} Freunde eingeladen',
  'settings.referral.toppedUp_one': '{{count}} hat aufgeladen',
  'settings.referral.toppedUp_other': '{{count}} haben aufgeladen',
  'settings.referral.pendingHint': 'Wartet auf erste Aufladung — erinnere sie!',
  'settings.referral.shareText': 'Vokabeln aus Fotos deines Lebens lernen. Beim Aufladen bekommen wir beide 150 Energie — probier Piccard:',
  'settings.referral.rewardBanner': 'Dein Freund hat aufgeladen — 150 Energie deinem Guthaben gutgeschrieben.',
  'settings.referral.rewardDismiss': 'Alles klar',
  'settings.referral.haveCode': 'Hast du einen Einladungscode?',
  'settings.referral.codePlaceholder': 'Code eingeben',
  'settings.referral.codeApply': 'Anwenden',
  'settings.referral.codeApplying': 'Wird angewendet…',
  'settings.referral.codeApplied': 'Code angewendet — wenn du auflädst, bekommst du und dein Einlader jeweils 150 Energie.',
  'settings.referral.codeAlready': 'Für dein Konto ist bereits eine Einladung hinterlegt.',
  'settings.referral.codeInvalid': 'Dieser Code ist ungültig.',
  'settings.referral.codeSelf': 'Das ist dein eigener Code.',

  // Payment (shared)
  'payment.checkoutFailed': 'Checkout konnte nicht gestartet werden. Erneut versuchen.',
  'payment.checkoutLoading': 'Checkout wird geöffnet …',
  'payment.checkoutSuccess': 'Aufladung erhalten — danke!',
  'payment.checkoutCancelled': 'Checkout abgebrochen.',

  // Hamburger menu
  'menu.notSignedIn': 'Nicht angemeldet',
  'menu.signOut': 'Abmelden',
  'menu.languageLearner': 'Sprachenlerner',

  // Onboarding
  'onboarding.iSpeak': 'Ich spreche…',
  'onboarding.imLearning': 'Ich lerne…',
  'onboarding.startLearning': 'Loslegen',
  'onboarding.changeAnytime': 'Du kannst das jederzeit ändern.',
  'onboarding.back': '← Zurück',
  'onboarding.learningContext.label': 'Lernst du für etwas Bestimmtes?',
  'onboarding.learningContext.placeholder': 'z. B. GRE, HSK, Business-Englisch… (optional)',

  // Auth
  'auth.signInPrompt': 'Melde dich an, um deinen Wortschatz in der Cloud zu speichern',
  'auth.continueWithGoogle': 'Mit Google fortfahren',
  'auth.continueWithKakao': 'Mit Kakao fortfahren',
  'auth.signingIn': 'Anmeldung läuft...',
  'auth.signingYouIn': 'Du wirst angemeldet...',
  'auth.signInFailed': 'Anmeldung fehlgeschlagen',
  'auth.signInError': 'Bei der Anmeldung ist etwas schiefgelaufen.',
  'auth.tryAgain': 'Erneut versuchen',
  'auth.loading': 'Wird geladen...',

  // Error boundary
  'error.title': 'Etwas ist schiefgelaufen',
  'error.description': 'Ein unerwarteter Fehler ist aufgetreten.',
  'error.tryAgain': 'Erneut versuchen',
  'error.report': 'Melden',

  // Offline
  'offline.title': 'Du bist offline',
  'offline.description': 'Einige Funktionen sind möglicherweise eingeschränkt. Prüfe deine Verbindung.',
  'offline.notification': 'Offline-Benachrichtigung',
  'offline.retryConnection': 'Verbindung erneut versuchen',

  // PWA install
  'pwa.installPrompt': 'Piccard für Offline-Nutzung installieren',
  'pwa.install': 'Installieren',
  'pwa.dismiss': 'Schließen',
  'pwa.installAppPrompt': 'App-Installationshinweis',
  'pwa.installApp': 'App installieren',

  // Card stack
  'cardStack.cardGenerated': '1 Karte erstellt',
  'cardStack.cardGenerated_other': '{{count}} Karten erstellt',
  'cardStack.counter': '{{current}} / {{total}} Karten',
  'cardStack.done': 'Fertig',
  'cardStack.reviewNow': 'Jetzt wiederholen',
  'cardStack.generateMore': 'Mehr erstellen',
  'cardStack.allReviewed': 'Alle Karten angesehen',
  'cardStack.cardsSaved': '{{count}} Karten gespeichert',
  'cardStack.previousCard': 'Vorherige Karte',
  'cardStack.nextCard': 'Nächste Karte',
  'cardStack.goToCard': 'Zu Karte {{n}} gehen',

  // Preview card
  'previewCard.generatedCard': 'Erstellte Karte',
  'previewCard.translation': 'Übersetzung',
  'previewCard.definition': 'Definition',
  'previewCard.example': 'Beispiel',
  'previewCard.searchImagesFor': 'Bilder für {{word}} suchen',

  // Rating buttons
  'rating.again': 'Nochmal',
  'rating.hard': 'Schwer',
  'rating.good': 'Gut',
  'rating.easy': 'Leicht',
  'rating.master': 'Gelernt',
  'rating.rateAs': 'Bewerten als {{label}}',
  'rating.markMastered': 'Als gelernt markieren',
  'review.stuckHint': "Diese Karte ist dir {{count}}× entglitten — nicht deine Schuld, manche Karten wollen einfach nicht hängen. Gib sie unten auf oder mach weiter.",

  // Study card
  'studyCard.studyCardFor': 'Lernkarte für: {{word}}',
  'studyCard.playUsPronunciation': 'US-Aussprache abspielen',
  'studyCard.playUkPronunciation': 'UK-Aussprache abspielen',
  'studyCard.searchImagesFor': 'Bilder für {{word}} suchen',

  // Pronunciation button + badge
  'pronunciation.play': '{{accent}}-Aussprache abspielen',

  // Search bar
  'search.clearSearch': 'Suche löschen',

  // Tag cloud
  'tagCloud.yourTopics': 'Deine Themen',
  'tagCloud.showMore': '{{count}} weitere {{label}} anzeigen',

  // Queue item
  'queueItem.remove': '{{word}} entfernen',

  // Error card
  'errorCard.defaultRetry': 'Erneut versuchen',

  // Empty state
  'emptyState.noCards': 'Noch keine Karten',
  'emptyState.noCardsHint': 'Erstelle deine erste Karte, um loszulegen',
  'emptyState.createCard': 'Karte erstellen',
  'emptyState.noMastered': 'Noch keine gelernten Wörter.',
  'emptyState.noMasteredHint': 'Markiere Karten als gelernt, um sie hier zu sehen.',
  'emptyState.allMastered': 'Alle deine Karten sind gelernt!',
  'emptyState.greatJob': 'Gut gemacht!',

  // Progress bar
  'progressBar.cardsLearned': 'Gelernte Karten',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'KI-Bild',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': 'KI-Bild für {{word}} erstellen',
  'common.generating': 'Wird erstellt…',
  'common.imageFailed': 'Fehlgeschlagen · keine Energie verbraucht',
  'common.lowEnergy': 'Wenig Energie',
  'common.regenerateCard': 'Neu generieren',
  'common.regenerateCardAria': '{{word}} komplett neu generieren',

  // Image preview / lightbox
  'imagePreview.enlarge': 'Bild vergrößern',
  'imagePreview.close': 'Schließen',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': 'Dokument importieren',
  'importView.subtitle': 'Wandle ein PDF oder einen Text in Vokabelkarten um.',
  'importView.chooseFile': 'PDF- oder Textdatei wählen',
  'importView.pasteLabel': 'Oder Text einfügen',
  'importView.pastePlaceholder': 'Füge deinen Artikel, Notizen oder beliebigen Text ein…',
  'importView.findVocab': 'Vokabular finden',
  'importView.proposing': 'Vokabular wird gesucht…',
  'importView.parsing': 'Dokument wird gelesen…',
  'importView.candidates': '{{count}} Vorschläge',
  'importView.keepN': '{{count}} behalten · {{energy}} Energie',
  'importView.generate': '{{count}} Karten erstellen',
  'importView.selectAll': 'Alle auswählen',
  'importView.clearAll': 'Alle abwählen',
  'importView.priorityHigh': 'Hoher Wert',
  'importView.highCount': '{{high}} hochwertig von {{total}}',
  'mediaView.selectRecommended': 'Empfohlene auswählen',
  'importView.success': '{{count}} Karten zur Bibliothek hinzugefügt',
  'importView.pairMismatch': 'Karten werden als {{pair}} gespeichert — deine App ist auf {{current}} eingestellt. Zum Wiederholen in den Einstellungen wechseln.',
  'importView.savedAs': 'Gespeichert als {{pair}}',
  'importView.reviewInPair': 'Zu {{pair}} wechseln & wiederholen',
  'importView.reviewNow': 'Jetzt wiederholen',
  'importView.errorTooLarge': 'Dokument zu groß (max. ~800K Zeichen).',
  'importView.errorScanned': 'Kein auswählbarer Text — sieht nach gescanntem PDF aus.',
  'importView.errorRead': 'Datei konnte nicht gelesen werden.',
  'importView.errorPropose': 'Vokabular konnte nicht extrahiert werden. Erneut versuchen.',
  'importView.errorRateLimited': 'Zu viele Anfragen hintereinander. Warte etwa eine Minute und versuche es erneut.',
  'importView.errorLowEnergy': 'Nicht genug Energie, um diese Karten zu speichern.',
  'importView.empty': 'Kein Vokabular gefunden. Versuche ein anderes Dokument.',
  'importView.proposingWait': 'Wörter werden ausgewählt und Definitionen geschrieben – bei langen Texten 10–20 Sekunden.',
  'importView.phaseReading': 'Dein Text wird gelesen…',
  'importView.foundSoFar': '{{n}} gefunden · es wird weiter gesucht…',
  'importView.cancel': 'Abbrechen',
  'importView.partialBanner': '{{n}} Wörter gefunden, aber die Analyse wurde vorzeitig beendet.',
  'importView.retryRest': 'Rest finden',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': 'In Piccard speichern',
  'quickSave.subtitle': 'Ein Tipp und deine Karte ist bereit zum Wiederholen.',
  'quickSave.generate': 'Karte erstellen',
  'quickSave.generateCost': 'Karte erstellen · {{energy}} Energie',
  'quickSave.generating': 'Karte wird erstellt…',
  'quickSave.slowWait': 'Das Erstellen deiner Karte dauert meist einige Sekunden.',
  'quickSave.pairSourceExtension': 'aus diesem Video',
  'quickSave.pairSourceSettings': 'App-Einstellung',
  'quickSave.pairSourceBrowser': 'Browsersprache',
  'quickSave.fromYoutube': 'Aus diesem Video',
  'quickSave.fromNetflix': 'Aus dieser Serie',
  'quickSave.pairLabel': 'Kartensprache',
  'quickSave.energyHint': 'Generieren kostet {{energy}} Energie · Guthaben {{balance}}',
  'quickSave.errorBalance': 'Nicht genug Energie, um diese Karte zu erstellen.',
  'quickSave.errorNetwork': 'Karte konnte nicht erstellt werden. Versuche es erneut.',
  'quickSave.topUp': 'Aufladen',
  'card.fromSource': 'Aus deinem Dokument',
  'card.grammar': 'Grammatik',
  'card.prosody': 'Betonung & Rhythmus',
  'card.fromClip': 'Ausschnitt',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': 'Bei Netflix öffnen',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': 'Dein Foto',
  'card.lookedUp': 'Nachgeschlagen',
  'card.expand': 'Ausklappen',
  'card.collapse': 'Einklappen',

  'mediaView.title': 'Aus einem Clip Karten machen',
  'mediaView.subtitle': 'Bringe englisches Audio oder Video. Wir transkribieren es, du wählst aus.',
  'mediaView.chooseFile': 'Datei hierher ziehen oder tippen',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': 'Bis zu 90 Min · bis zu 100 MB',
  'mediaView.guideExtension.body': 'Erweiterung installiert? Wähle auf einer YouTube/Netflix-Videoseite ein Untertitelwort an und tippe auf den Piccard-Button, um eine Karte zu speichern. Unten kannst du auch eigene Video-/Audiodateien importieren →',
  'mediaView.guideExtension.dismiss': 'Schließen',
  'mediaView.uploading': 'Wird hochgeladen …',
  'mediaView.transcribe': 'Transkribieren',
  'mediaView.transcribing': 'Wird transkribiert …',
  'mediaView.transcribeHint': 'Ein kurzer Clip dauert wenige Sekunden.',
  'mediaView.changeFile': 'Datei ändern',
  'mediaView.costN': '{{energy}} Energie',
  'mediaView.phrases': '{{count}} Phrasen',
  'mediaView.make': '{{count}} Karten erstellen',
  'mediaView.uncertain': 'Diese Phrase prüfen',
  'mediaView.preview': 'Diese Phrase abspielen',
  'mediaView.success': '{{count}} Karten bereit zum Wiederholen',
  'mediaView.errorUpload': 'Upload fehlgeschlagen. Erneut versuchen.',
  'mediaView.errorTooLarge': 'Über 100 MB — bitte kürzer schneiden.',
  'mediaView.errorSilent': 'Keine hörbare Sprache gefunden. evtl. stummes Video — wähle einen Clip mit Dialog.',
  'mediaView.errorFormat': 'Format nicht unterstützt. Nutze mp4, mov, webm oder eine Audiodatei.',
  'mediaView.errorTranscribe': 'Transkriptionsdienst beschäftigt. Wiederholen — nicht berechnet.',
  'mediaView.tooLongDuration': 'Über {{n}} Minuten — kürze den Clip und füge ihn erneut hinzu.',
  'mediaView.errorContent': 'Keine englische Sprache in dieser Datei gefunden.',
  'mediaView.errLanguageMismatch': 'Dieser Clip klingt nicht nach {{lang}}. Wähle {{lang}}-Material oder wechsle zuerst deine Lernsprache.',
  'mediaView.errBadFormat': 'Das tatsächliche Format dieser Datei lässt sich nicht transkribieren (z. B. .avi/.mkv als .mp4 umbenannt). Konvertiere sie zu mp4, mov, webm oder einem Standard-Audioformat.',
  'mediaView.errNoSpeech': 'In dieser Datei wurde keine Sprache erkannt. Wähle einen Clip mit klarem Dialog.',
  'mediaView.errDecode': 'Das Audio dieser Datei konnte nicht verarbeitet werden. Versuche eine Standard-mp4-, mov-, webm- oder Audiodatei.',
  'mediaView.fromFile': 'von {{name}}',
  'mediaView.errorLowEnergy': 'Nicht genug Energie.',
  'mediaView.errorConfirm': 'Aus diesen Phrasen konnten keine Karten erstellt werden. Erneut versuchen.',
  'mediaView.empty': 'Keine Phrasen in diesem Clip gefunden.',
  'mediaView.costEstimate': '~{{cost}} Energie · ~{{min}} Min.',
  'mediaView.feeApplied': '({{n}} Energie Erkennungsgebühr abgezogen)',
  'settings.section.energy': 'Energie',
  'settings.section.learning': 'Lernen',
  'redeem.title': 'Code einlösen',
  'redeem.desc': 'Gib einen Code ein, um Energie zu erhalten.',
  'redeem.placeholder': 'Code eingeben',
  'redeem.apply': 'Einlösen',
  'redeem.applying': '…',
  'redeem.success': 'Eingelöst! +{{cents}} Energie',
  'redeem.already': 'Du hast diesen Code bereits eingelöst.',
  'redeem.invalid': 'Ungültiger oder abgelaufener Code',
  'redeem.error': 'Etwas ist schiefgelaufen. Versuche es erneut.',
  'redeem.balance': '{{balance}} Energie verfügbar',

  // Landing page (v11 — extension-first entry, closed loop. Copy frozen in
  // docs/plans/landing-v11.md; locale from ?lang / ?ref hint / navigator.languages)
  'landing.hero.title': 'Englisch lernen\nmit YouTube.',
  'landing.hero.subtitle': 'Zweisprachige Untertitel bei den englischen Videos, die du schaust. Tippe auf eine Zeile und mach mit einem Klick die Karten — Bedeutung, Beispielsatz, Aussprache — und jede einzelne kommt wieder, kurz bevor du sie vergisst.',
  'landing.hero.cta': 'Loslegen',
  'landing.hero.ctaNote': 'Kostenlos. Keine Kreditkarte nötig.',
  'landing.hero.ctaExtension': 'Zu Chrome hinzufügen',
  'landing.hero.videoCaption': 'Aus dem zweisprachigen Panel nach Piccard — aus einer Zeile werden mehrere Karten-Vorschläge.',
  'landing.how.title': 'Vokabeln aus Videos lernen',
  'landing.how.subtitle': 'Der Kreislauf schließt sich: Was du schaust, wird zu Lernkarten, die du wiederholst.',
  'landing.how.step1Title': 'Mit zweisprachigen Untertiteln schauen',
  'landing.how.step1Desc': 'Die Chrome-Erweiterung legt Untertitel in deiner Sprache über das Video, das du gerade schaust — jede Zeile, sekundengenau.',
  'landing.how.step2Title': 'Eine Zeile antippen. Die Karten behalten.',
  'landing.how.step2Desc': 'Ein Tipp schickt die Zeile zu Piccard. Ein Klick macht die Karten — mit Bedeutung, Beispielsatz und Aussprache. Behalte, was sich zu behalten lohnt, wirf den Rest weg.',
  'landing.how.step3Title': 'Die Wiederholung kommt zu dir zurück',
  'landing.how.step3Desc': 'Spaced Repetition mit FSRS plant jede Karte so, dass sie kurz bevor du sie vergisst zurückkommt — und jede spielt den exakten YouTube-Moment ab, aus dem sie stammt.',
  'landing.how.otherTitle': 'Andere Einstiege',
  'landing.how.other3': 'Doppelklick auf ein Wort im Web — eine Offline-Definition erscheint, und Piccard erstellt die Karte mit einem weiteren Klick.',
  'landing.how.ownLink': 'Du hast schon eine Wortliste? Bring sie mit →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': 'Bring deine eigene Liste mit',
  'landing.bring.subtitle': 'Videos sind nur ein Einstieg. Die meisten Wörter, die du brauchst, liegen schon irgendwo — ein Kapitel aus dem Lehrbuch, die Liste einer Prüfung, eine Vorlesungsaufnahme. Einfügen oder hochladen: Piccard schlägt die Karten vor, und du behältst die, die es wert sind.',
  'landing.bring.pasteTitle': 'Text einfügen',
  'landing.bring.pasteDesc': 'Eine Lehrbuchseite, ein Artikel, die Wortliste, die du schon hast. Einfügen — und die vorgeschlagenen Karten kommen zurück: alles auswählen oder nur das Behaltenswerte. Bis zu 20 Karten pro Bestätigung.',
  'landing.bring.pdfTitle': 'PDF ablegen',
  'landing.bring.pdfDesc': 'Kursmaterial, Prüfungswortlisten, Lesetexte — ein PDF läuft durch denselben Vorschlag. Karten liegen bereit, du wählst aus, eine Bestätigung.',
  'landing.bring.fileTitle': 'Audio oder Video hochladen',
  'landing.bring.fileDesc': 'Eine Vorlesung oder ein Podcast auf Englisch (bis 90 Minuten) wird transkribiert — jede Zeile bekommt einen 0–100-Score dafür, wie sehr sich das Lernen lohnt (dein Lernziel zählt), und die Empfehlungen kommen vorausgewählt. Audio in der Sprache, die du lernst (Englisch, wenn du Englisch lernst).',
  'landing.bring.cta': 'App öffnen',
  'landing.bring.ctaNote': 'Kostenlos starten. Keine Kreditkarte nötig.',
  'landing.pricing.title': 'Zahle nur, was du nutzt',
  'landing.pricing.subtitle': 'Starte mit kostenloser Energie. Jederzeit aufladen — sie läuft nie ab.',
  'landing.pricing.starter': 'Starter',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': 'zum Start',
  'landing.pricing.starterGrant': '150 kostenlose Energie bei Anmeldung',
  'landing.pricing.starterSwitch': 'Sprache jederzeit wechseln',
  'landing.pricing.starterSrs': 'Vollständige Spaced Repetition',
  'landing.pricing.starterDevices': 'Funktioniert auf jedem Gerät',
  'landing.pricing.starterSync': 'Cloud-Sync inklusive',
  'landing.pricing.starterCta': 'Loslegen',
  'landing.pricing.topup': 'Auflade-Pakete',
  'landing.pricing.topupRate': '1 Energie ≈ 1 Textkarte',
  'landing.pricing.starterAiImage': 'Textkarten inklusive; KI-Bildkarten sind eine kostenpflichtige Funktion',
  'landing.pricing.topupCards': '500 Karten für $5',
  'landing.blog.backHome': '← Startseite',
  'landing.welcome.openApp': 'Piccard öffnen',
  'landing.faq.heading': 'Häufig gestellte Fragen',
  'landing.faq.q1': 'Ist Piccard wirklich kostenlos?',
  'landing.faq.a1': 'Ja! Jedes neue Konto bekommt 150 kostenlose Energie — genug für ein paar Videos, PDFs oder rund 150 Karten. Lade nur nach, wenn du mehr willst, mit Energie-Paketen ($5/$10/$20). Energie läuft nie ab.',
  'landing.faq.q2': 'Wie unterscheidet sich das von Language Reactor oder Anki?',
  'landing.faq.a2': 'Beides sind gute Werkzeuge mit einer Lücke dazwischen: Language Reactor zeigt Untertitel, aber Wörter speichern heißt Export und Re-Import in Anki, und Anki selbst braucht echte Einrichtung — du baust jede Karte selbst. Piccard schließt diese Lücke. Tippe auf eine Untertitelzeile und die Karten sind schon fertig — Bedeutung, Beispielsatz, Aussprache. Behalte, was sich lohnt, wirf den Rest weg, und FSRS-6, der neuere Planer, den Anki ebenfalls anbietet, übernimmt die Spaced Repetition. Und bei längeren Imports bekommt jede Phrase einen 0–100-Score dafür, wie sehr sich das Lernen lohnt — einzeilige Begründung beim Hover, dein Lernziel fließt mit ein —, du musst nie mehr raten, welche Wörter deine Zeit verdienen. Keine Konfiguration, keine Export/Import-Brücke.',
  'landing.faq.q3': 'Verlangsamt es YouTube oder zerstört die Untertitel?',
  'landing.faq.a3': 'Nein. Die Erweiterung ist leichtgewichtig — sie legt ihr eigenes Untertitel-Panel über das Video und verändert YouTube selbst nie. Willst du sie irgendwann weg, entfernt ein Klick alles. Sie funktioniert auch ohne Konto.',
  'landing.faq.q5': 'Was ist Spaced Repetition?',
  'landing.faq.a5': 'Ein Planungsalgorithmus entscheidet, wann jede Karte zurückkommt — früh, solange sie frisch ist, später, wenn sie ins Langzeitgedächtnis übergeht. Piccard nutzt FSRS-6, die neueste Generation der Wissenschaft hinter Anki, und deine Karten entstehen aus dem, was du schaust und liest.',
  'landing.faq.q7': 'Welche Sprachen unterstützt Piccard?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 zuerst — Piccard ist für Koreaner, Traditionell-Chinesen und Japaner gebaut, die Englisch lernen. Spanisch, Französisch und Deutsch sind ebenfalls verfügbar. Wechsle jederzeit.',

  'landing.faq.q8': 'Ich habe schon eine Wortliste. Kann Piccard daraus Karten machen?',
  'landing.faq.a8': 'Ja — das ist der schnellste Einstieg. Text einfügen oder PDF ablegen, und Piccard schlägt die Karten vor (bis zu 20 auf einmal): Bedeutung, Beispielsatz, Aussprache. Vorlesungsaufnahmen gehen auch — Audio hochladen, es wird transkribiert, und jede Zeile bekommt einen 0–100-Score.',
  'landing.faq.q9': 'Funktioniert es auch bei Netflix?',
  'landing.faq.a9': 'Ja, bei Titeln mit Textuntertiteln — bietet der Titel beide Sprachen an, zeigt Piccard zweisprachige Untertitel (Englisch + deine Sprache) direkt im Video. Schau mit geöffnetem Piccard-Panel, tippe eine Zeile an — daraus wird eine Karte, die zurück zum exakten Sekundenpunkt auf Netflix führt. Einige Titel nutzen bildbasierte Untertitel, die nicht lesbar sind; und wegen DRM gibt es keine Screenshots oder Audioclips — behalten bleibst du die Wörter und den Moment.',
  'landing.faq.still': 'Noch Fragen? Schreib an',
  'landing.footer.tagline': 'Lernkarten aus dem, was du schaust',
  'landing.footer.blog': 'Blog',
  'landing.footer.privacy': 'Datenschutz',
  'landing.footer.terms': 'Nutzungsbedingungen',
  'landing.footer.contact': 'Kontakt',
  'landing.footer.rights': 'Alle Rechte vorbehalten.',
  'landing.finalCta.title': 'Deine erste Lernkarte ist nur ein YouTube-Video entfernt',
  'landing.finalCta.subtitle': 'Schau etwas. Tippe auf eine Zeile. Mach die Karte — sie kommt zurück, bevor du sie vergisst.',
  'landing.finalCta.cta': 'Kostenlos anfangen',
  'landing.finalCta.ctaExtension': 'Zu Chrome hinzufügen',
  'landing.finalCta.note': 'Keine Kreditkarte nötig. 150 Energie inklusive.',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'Englisch lernen mit YouTube – zweisprachige Untertitel | Piccard',
  'seo.description': 'Zweisprachige Untertitel auf YouTube. Zeile antippen, die lernenswerten Wörter als Lernkarten behalten — FSRS bringt jedes zurück, bevor du es vergisst.',
}
